import React from "react";
import "./introvideo.scss";

export default function Introvideo(){
  return(
    <div className="introvideo" id="introvideo">
    <div className="container">
    </div>
   <div className="Headingintrovideo">
   Our experts know their stuff
   </div>
   <div className="Video">
   <iframe width="795" height="422" src="https://www.youtube.com/embed/FnTALpYLoSU" title="Is it worth Studying abroad? | Leverage Edu" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
   </div>
   </div>

  )
}
